/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Spinner, Dropdown, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faSignOut,
  faSignIn,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import "./Header.scss";
import useHeader from "./useHeader";

export default (props) => {
  const {
    loading,
    userMetaData,
    onSignOutClick,
    viewProfile,
    viewNotifications,
    viewJobBoard,
    onDemoViewClick,
    viewMentors,
    viewCandidates,
    viewCompanies,
    viewBucketList,
    viewSharedBucket,
    viewHiringPipeline,
    viewAssessmentkits,
    viewDashboardClick,
  } = useHeader();
  const { menuOpenHandler } = props;
  return (
    <header className="header position-fixed bg-white border-bottom px-3">
      <div className="header-wrapper d-flex w-100 align-items-center py-1">
        <div className="left d-flex d-lg-none mr-3">
          <button
            className="bg-transparent border-0 d-inline-block cursor-pointer"
            onClick={viewDashboardClick}
          >
            <img
              src="/assets/images/logo.svg"
              alt="logo"
              className="cursor-pointer"
            />
          </button>
        </div>
        <div className="right d-flex align-items-center justify-content-between postion-relative">
          <h2 className="text-capitalize my-3 my-md-0">{props.pageName}</h2>
          <div className="d-flex align-items-center">
            {userMetaData?.id ? (
              <FontAwesomeIcon
                icon={faBell}
                className="icon mx-3 cursor-pointer d-none d-md-block"
                onClick={viewNotifications}
              />
            ) : null}

            <Dropdown as={ButtonGroup} className="d-none d-md-flex">
              <button className="profile-btn border-0 bg-white">
                <img
                  src={
                    userMetaData?.user_meta_info &&
                    userMetaData.user_meta_info?.profile_image
                      ? userMetaData?.user_meta_info &&
                        userMetaData.user_meta_info?.profile_image
                      : "/assets/images/user.png"
                  }
                  alt="user"
                  className="rounded-circle cursor-pointer user-image"
                />
              </button>

              <Dropdown.Toggle
                variant=""
                split
                id="dropdown-split-basic"
                className="p-0"
              />

              {userMetaData?.id ? (
                <Dropdown.Menu className="text-center">
                  <Dropdown.Item
                    onClick={viewProfile}
                    eventKey="option-1"
                    className="font-weight-medium"
                  >
                    {" "}
                    My Profile
                  </Dropdown.Item>
                  <button
                    onClick={onSignOutClick}
                    className="btn btn-primary d-flex justify-content-center align-items-center py-2  m-2 border-radius-10 mx-auto"
                  >
                    {loading ? (
                      <div className="d-flex justify-content-center align-items-center w-100">
                        <Spinner animation="border" variant="white" />
                      </div>
                    ) : (
                      <p className="mb-0">
                        <FontAwesomeIcon icon={faSignOut} className="mr-2" />
                        Logout
                      </p>
                    )}
                  </button>
                </Dropdown.Menu>
              ) : (
                <Dropdown.Menu>
                  <a
                    href="/sign-in"
                    onClick={onSignOutClick}
                    className="btn btn-primary d-flex justify-content-center py-2  m-2 border-radius-10 align-items-center"
                  >
                    <FontAwesomeIcon icon={faSignIn} className="mr-2" /> SignIn
                  </a>
                </Dropdown.Menu>
              )}
            </Dropdown>

            <button
              className="border-0 bg-transparent ml-3"
              onClick={() => menuOpenHandler()}
            >
              <FontAwesomeIcon
                icon={faBars}
                className="menu-open d-inline-block d-lg-none  cursor-pointer"
              />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
